import { Search, Filter, X } from 'lucide-react'
import { Button } from '../common'

function CustomerFilters({ 
  searchTerm, 
  onSearchChange, 
  onClearFilters,
  totalItems 
}) {
  return (
    <div className="card">
      <div className="card-content">
        <div className="flex flex-col sm:flex-row sm:items-center sm:justify-between space-y-4 sm:space-y-0">
          {/* Search */}
          <div className="flex-1 max-w-lg">
            <div className="relative">
              <div className="absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none">
                <Search className="h-5 w-5 text-secondary-400" />
              </div>
              <input
                type="text"
                value={searchTerm}
                onChange={(e) => onSearchChange(e.target.value)}
                className="input pl-10"
                placeholder="Search customers by name, email, or phone..."
              />
            </div>
          </div>

          {/* Results and Actions */}
          <div className="flex items-center space-x-4">
            {/* Results count */}
            <div className="text-base text-secondary-600">
              {totalItems > 0 ? (
                <span>
                  {totalItems} customer{totalItems !== 1 ? 's' : ''} found
                </span>
              ) : (
                <span>No customers found</span>
              )}
            </div>

            {/* Clear filters */}
            {searchTerm && (
              <Button
                onClick={onClearFilters}
                variant="outline"
                size="sm"
                className="flex items-center"
              >
                <X className="h-4 w-4 mr-1" />
                Clear
              </Button>
            )}

            {/* Filter button (for future use) */}
            <Button
              variant="outline"
              size="sm"
              className="flex items-center"
              disabled
            >
              <Filter className="h-4 w-4 mr-1" />
              Filters
            </Button>
          </div>
        </div>

        {/* Active filters display */}
        {searchTerm && (
          <div className="mt-4 pt-4 border-t border-secondary-200">
            <div className="flex items-center space-x-2">
              <span className="text-base text-secondary-600">Active filters:</span>
              <div className="flex items-center space-x-2">
                <span className="inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium bg-primary-100 text-primary-800">
                  Search: "{searchTerm}"
                </span>
              </div>
            </div>
          </div>
        )}
      </div>
    </div>
  )
}

export default CustomerFilters
